import React from 'react';
import * as styles from './Footer.module.scss';
import {GatsbyImage} from "gatsby-plugin-image";
import {TwitterIcon} from "components/organisms/Video/Footer/icons";
import cls from "classnames";

type Props = {
    authors: Queries.AuthorsJson[],
    publishedAt: Date,
    duration: string
}

export const Footer = ({authors, publishedAt, duration}: Props) => {


    return (
        <>
            {authors.map((item, index) => {
                return <>
                    {item?.data?.name?.iv &&
                        <div className={styles.container}>
                            {item?.authorImage?.childImageSharp?.gatsbyImageData &&
                                <GatsbyImage className={styles.avatar} alt={item?.data?.name?.iv}
                                             image={item?.authorImage?.childImageSharp?.gatsbyImageData}/>}
                            <div className={styles.content}>
                                <div className={styles.info}>
                                    <span className={styles.name}>{item?.data?.name?.iv}</span>
                                </div>
                                <div className={cls(styles.social, "color-gray")}>
                                    {publishedAt.toLocaleString('en-US',
                                        {month:'long', day: '2-digit',
                                            year: 'numeric', timeZone: 'America/Los_Angeles'}
                                    )} • <span className={cls(styles.duration, "color-gray")}>{duration}</span>
                                </div>
                            </div>
                        </div>
                    }
                </>
            })}
        </>

    )
}
